import { IdMapping } from '../models/offlineOperation.model';

/**
 * Replaces temporary IDs in an object with their corresponding server IDs
 * @param obj The object to process
 * @param idMappings The mapping of temporary IDs to server IDs
 * @returns The object with replaced IDs
 */
export function replaceTempIdsInObject(obj: any, idMappings: { [tempId: string]: IdMapping }): any {
  if (!obj || typeof obj !== 'object' || Object.keys(idMappings).length === 0) {
    // console.log('replaceTempIdsInObject: Skipping due to invalid object or empty mappings.', { obj, idMappings });
    return obj;
  }

  if (Array.isArray(obj)) {
    // console.log('replaceTempIdsInObject: Processing array.', obj);
    return obj.map(item => replaceTempIdsInObject(item, idMappings));
  }


  const result = { ...obj };


  Object.entries(result).forEach(([key, value]) => {

    if (typeof value === 'string' && value.startsWith('offline-')) {
      const mapping = idMappings[value];
      if (mapping) {
        // console.log(`replaceTempIdsInObject: Replacing temp ID: ${value} -> ${mapping.serverId} for key: ${key}`);
        result[key] = mapping.serverId;
      } else {
        // console.warn(`replaceTempIdsInObject: No mapping found for temp ID: ${value}`);
      }
    }

    else if (typeof value === 'object' && value !== null) {
      // console.log(`replaceTempIdsInObject: Recursing into key: ${key} with value:`, value);
      result[key] = replaceTempIdsInObject(value, idMappings);
    }
  });

  return result;
}

export function replaceTempIdsInArray(obj: any, idMappings: Array<IdMapping>): any {
  if (!obj || typeof obj !== 'object' || idMappings.length === 0) {
    // console.log('replaceTempIdsInObject: Skipping due to invalid object or empty mappings.', { obj, idMappings });
    return obj;
  }

  if (Array.isArray(obj)) {
    // console.log('replaceTempIdsInObject: Processing array.', obj);
    return obj.map(item => replaceTempIdsInArray(item, idMappings));
  }


  const result = { ...obj };


  Object.entries(result).forEach(([key, value]) => {
    if (typeof value === 'string' && value.startsWith('offline-')) {
      // console.log(key, '==', value)
      // console.log('idMappings', '=', idMappings)

      const mapping = idMappings.find((val) => val.tempId == value);

      if (mapping) {
        // console.log(`replaceTempIdsInObject: Replacing temp ID: ${mapping.tempId} -> ${mapping.serverId} for key: ${mapping.tempId}`);
        result[key] = mapping.serverId;
      } else {
        console.warn(`replaceTempIdsInObject: No mapping found for temp ID: ${mapping.tempId}`);
      }
    }

    else if (typeof value === 'object' && value !== null) {
      // console.log(`replaceTempIdsInObject: Recursing into key: ${key} with value:`, value);
      result[key] = replaceTempIdsInArray(value, idMappings);
    }
  });

  return result;
}
/**
 * Replaces temporary IDs in a URL with their corresponding server IDs
 * @param url The URL to process
 * @param idMappings The mapping of temporary IDs to server IDs
 * @returns The URL with replaced IDs
 */
export function replaceTempIdsInUrl(url: string, idMappings: { [tempId: string]: IdMapping }): string {
  if (!url || Object.keys(idMappings).length === 0) {
    // console.log('replaceTempIdsInUrl: Skipping due to invalid URL or empty mappings.', { url, idMappings });
    return url;
  }

  let updatedUrl = url;

  Object.entries(idMappings).forEach(([tempId, mapping]) => {

    if (updatedUrl.includes(tempId)) {
      // console.log(`replaceTempIdsInUrl: Replacing temp ID in URL: ${tempId} -> ${mapping.serverId}`);
      updatedUrl = updatedUrl.replace(tempId, mapping.serverId.toString());
    }
  });

  return updatedUrl;
}